import { resolveInvite as resolve } from '../services/api/guest';
import actionTypes from './action_types';

export function resolveInvite(inviteId) {
  return (dispatch) => {
    return resolve(inviteId)
      .then(({ invite }) => {
        return dispatch({
          type: actionTypes.INVITE_RESOLVED,
          payload: { invite },
        });
      })
      .catch(() => {
        return dispatch({
          type: actionTypes.INVITE_RESOLVED,
          payload: { invite: null },
        });
      });
  };
}

export function clearInvite() {
  return (dispatch) => {
    return dispatch({
      type: actionTypes.INVITE_RESOLVED,
      payload: { invite: null },
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/guest.js